import { TFormStateMode } from '../../types/redux/forms';

export const getIsFormItemDisabled = (formMode: TFormStateMode | undefined, disabled: boolean, ediatable: boolean) => {
    if (disabled) {
        return true;
    }
    return formMode === 'edit' ? false : ediatable === false;
};

export const getFormItemClassName = (defaultClassName: string, additionalClassName?: string) => {
    if (typeof additionalClassName === 'string') {
        return `${defaultClassName} ${additionalClassName}`;
    }
    return defaultClassName;
};
